import React from "react"
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
} from "react-router-dom"

import PaymentPage from "pages/PaymentPage/PaymentPage"
import SongRatingPage from "pages/SongRatingPage/SongRatingPage"
import SongPage from "pages/SongPage/SongPage"
import SongDebugPage from "pages/SongDebugPage/SongDebugPage"
import UserPage from "pages/UserPage/UserPage"
import HandleReservationPage from "pages/HandleReservationPage/HandleReservationPage"

const routes = (
  <>
    <Switch>
      <Route path="/user/:userId/song/:songId" component={SongPage} />
      <Route path="/song/:songId" component={SongPage} />
      <Route path="/ratesong/:songId" component={SongRatingPage} />
      <Route path="/user/:userId/songdebug/:songId" component={SongDebugPage} />
      <Route path="/songdebug/:songId" component={SongDebugPage} />
      <Route path="/user/:userHandle" component={UserPage} />
      <Route path="/creators/:userHandle" component={UserPage} />
      <Route path="/@:userHandle" component={UserPage} />
      <Route exact path="/pay" component={PaymentPage} />
      <Route exact path="/reserveHandle" component={HandleReservationPage} />
      <Redirect to='/pay' />
    </Switch>
  </>
)

export default routes
